import React from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";

export const BagConnectionFilterGroup = ({
  bagFilters,
  connectionFilters,
  onBagToggle,
  onConnectionToggle,
}) => {
  return (
    <FormGroup>
      {bagFilters.map(({ key, label, count, checked }) => (
        <FormControlLabel
          key={key}
          control={
            <Checkbox checked={checked} onChange={onBagToggle} name={key} />
          }
          label={
            <span style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2" sx={{ mr: 0.5, fontWeight: "bold" }}>
                {label}
              </Typography>
              <Typography component="span" variant="caption">
                ({count} pax)
              </Typography>
            </span>
          }
        />
      ))}

      {connectionFilters.map(({ key, label, count, checked }) => (
        <FormControlLabel
          key={key}
          control={
            <Checkbox
              checked={checked}
              onChange={onConnectionToggle}
              name={key}
            />
          }
          label={
            <span style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2" sx={{ mr: 0.5, fontWeight: "bold" }}>
                {label}
              </Typography>
              <Typography component="span" variant="caption">
                ({count})
              </Typography>
            </span>
          }
        />
      ))}
    </FormGroup>
  );
};
